import styled, { css } from 'styled-components';
var Container = styled.div.withConfig({
  displayName: "Commonstyles__Container",
  componentId: "sc-1bww48k-0"
})(["display:flex;flex-direction:column;gap:", ";@media screen and (min-width:", "){flex-direction:row;}"], function (props) {
  return props.theme.size.spacing['2xl'];
}, function (props) {
  return props.theme.size.breakpoint['min-width'].md;
});
var Header = styled.div.withConfig({
  displayName: "Commonstyles__Header",
  componentId: "sc-1bww48k-1"
})(["display:flex;justify-content:space-between;align-items:flex-end;", ""], function (props) {
  return !props.heading && css(["justify-content:flex-end;"]);
});
var Heading = styled.h2.withConfig({
  displayName: "Commonstyles__Heading",
  componentId: "sc-1bww48k-2"
})(["&&{font-size:", ";font-weight:", ";margin-top:", ";margin-bottom:0;}"], function (props) {
  return props.theme.font.size['body-2'];
}, function (props) {
  return props.theme.font.weight.bold;
}, function (props) {
  return props.theme.size.spacing['2xl'];
});
var SubHeading = styled.h3.withConfig({
  displayName: "Commonstyles__SubHeading",
  componentId: "sc-1bww48k-3"
})(["&&{margin-top:", ";font-size:", ";font-weight:", ";}"], function (props) {
  return props.theme.size.spacing.base;
}, function (props) {
  return props.theme.font.size['body-1'];
}, function (props) {
  return props.theme.font.weight.regular;
});
var Title = styled.h4.withConfig({
  displayName: "Commonstyles__Title",
  componentId: "sc-1bww48k-4"
})(["&&{margin-bottom:0;font-size:", ";font-weight:", ";}"], function (props) {
  return props.theme.font.size['body-1'];
}, function (props) {
  return props.theme.font.weight.bold;
});
var Description = styled.p.withConfig({
  displayName: "Commonstyles__Description",
  componentId: "sc-1bww48k-5"
})(["&&{margin:0;font-size:", ";font-weight:", ";}"], function (props) {
  return props.theme.font.size['body-1'];
}, function (props) {
  return props.theme.font.weight.regular;
});
var MeasurementsContainer = styled.div.withConfig({
  displayName: "Commonstyles__MeasurementsContainer",
  componentId: "sc-1bww48k-6"
})(["flex:1 0 50%;overflow-x:auto;> * + *{margin-top:", ";}"], function (props) {
  return props.theme.size.spacing.xl;
});
var HowToMeasureContainer = styled.div.withConfig({
  displayName: "Commonstyles__HowToMeasureContainer",
  componentId: "sc-1bww48k-7"
})(["flex:1 1 50%;> * + *{margin-top:", ";}"], function (props) {
  return props.theme.size.spacing.xl;
});
var sharedListStyles = css(["list-style-position:inside;margin-top:", ";padding-left:", ";& + p{margin-top:", ";}"], function (props) {
  return props.theme.size.spacing.md;
}, function (props) {
  return props.theme.size.spacing.xl;
}, function (props) {
  return props.theme.size.spacing.xl;
});
var UnorderedList = styled.ul.withConfig({
  displayName: "Commonstyles__UnorderedList",
  componentId: "sc-1bww48k-8"
})(["&&{", " list-style-type:disc;}"], sharedListStyles);
var OrderedList = styled.ol.withConfig({
  displayName: "Commonstyles__OrderedList",
  componentId: "sc-1bww48k-9"
})(["", " list-style-type:decimal;"], sharedListStyles);
var ImageWrapper = styled.div.withConfig({
  displayName: "Commonstyles__ImageWrapper",
  componentId: "sc-1bww48k-10"
})(["& img{width:100%;}"]);
export { Container, Header, Heading, SubHeading, Title, Description, MeasurementsContainer, HowToMeasureContainer, UnorderedList, OrderedList, ImageWrapper };